import { render, staticRenderFns } from "./SearchLoggingHeader.vue?vue&type=template&id=44972007&"
import script from "./SearchLoggingHeader.vue?vue&type=script&lang=js&"
export * from "./SearchLoggingHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchLoggingHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports